import Builder, { initialValues as builderInitialValues } from './Builder';
import Player from './Player';

export default {
    handle: 'overallFidelityChart',
    label: 'Overall Fidelity Chart',
    builderInitialValues,
    builder: Builder,
    player: Player,
};
